import { projectInfoModalStrings } from "../utils/StringConstants";

import chinaFlag from "../common/icons/china-flag.svg";
import usaFlag from "../common/icons/usa-flag.svg";

export const SESSION_TIMEOUT_MS = 1800000;
export const MIN_PROJECT_NAME_LENGTH = 3;
export const MAX_PROJECT_NAME_LENGTH = 200;
export const PROJECT_NAME_MAX_LENGTH = 20; //Length of project name
export const MAX_UPLOAD_FILE_SIZE = 250 * 1024 * 1024;
export const TOAST_DEFAULT_DURATION = 3000; //3 seconds
export const TOAST_DEFAULT_DURATION_ERROR = 5000; //5 seconds
export const DATE_FORMAT = "MMM DD, YYYY, hh:mm:ss A z";
export const COUNTRY_STATE_ID = 0;
export const CHARGE_BALANCE_THRESHOLD = 0.000099;
export const MAX_CURRENCY_EXCHANGE_RATE = 1000000;
export const MAX_NOTIFICATION_COUNT_DISPLAY = 99;
export const USER_INFO = {
  languageId: 1,
  name: "English (USA)",
  enabled: true,
  cultureName: "en",
  translatedName: "English (USA)",
};

export const FEATURE_SCOPE = {
  PLANT: "plantLevel",
  USER: "userLevel",
};

export const FEATURE_TOUR_KEYS = {
  CHEMICAL_UTILITY_COST: "CHEMICAL_UTILITY_COST",
};

export const APP_ROUTES = {
  ROOT: "",
  PLANTS: "plants",
  PLANT_LEGACY: "plant",
  ADD_PLANT: "addPlant",
  EDIT_PLANT: "editPlant",
  ANALYSE_DATA: "analyseData",
  HOME: "home",
  CLEANING_ADVISOR_HOME: "cleaningAdvisorHome",
  LIFETIME_ADVISOR_HOME: "lifetimeAdvisorHome",
  UNAUTHORIZED: "unauthorized",
  REQUEST_ACCESS: "requestAccess",
  MESSAGE_PAGE: "messagePage",
  ADMIN_PORTAL: "admin-portal",
  USER_MANAGEMENT: "user-management",
};

export const APP_SCOPE = {
  CA: "ca", // Cleaning Advisor
  RA: "ra", // Lifetime Advisor (RA - Replacement Advisor)
  BASE: "base", // Base API without app prefix
  AUTO: "auto", // Default option:Automatically determine based on current route
};

export const LOCAL_STORAGE_KEYS = {
  TROUBLESHOOTING_READ_TOPICS: "troubleshootingReadTopics",
};

export const TROUBLESHOOTING_TOPICS = {
  DATASET_UPLOAD: "datasetUpload",
  AUTO_DETECT_COLUMNS: "autoDetectColumns",
  FILE_SHEET_MAPPING: "fileSheetMapping",
};

export const FILE_SHEET_MAPPING_COLUMN_TYPES = {
  MANUAL: "manual",
  AUTO: "auto",
};

export const FEATURE_TOUR_SESSION_KEYS = {
  COMPLETED_LIST: "completedFeatureTourList",
};

export const PENDING_PLANT_CHEMICAL_LIBRARY_KEY = "pendingPlantChemicalLibrary";
export const PENDING_PLANT_UTILITY_COSTS_KEY = "pendingPlantUtilityCosts";
export const PENDING_PLANT_BASELINE_UNITS_KEY = "pendingPlantBaselineUnits";

export const UTILITY_FIELD_KEY_TO_API_KEY = {
  priceOfWater: "water_price",
  costOfDowntime: "downtime_cost",
  costOfElectricity: "energy_price",
};

export const UTILITY_API_KEY_TO_FIELD_KEY = {
  water_price: "priceOfWater",
  downtime_cost: "costOfDowntime",
  energy_price: "costOfElectricity",
};

export const TIME_UNITS = {
  minutes: "minute",
  hours: "hour",
  days: "day",
  weeks: "week",
  months: "month",
  years: "year",
};

export const EMAIL_VALIDATOR = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const KEYBOARD_KEYS = {
  ENETR: "Enter",
  TAB: "Tab",
  ARROWUP: "ArrowUp",
  ARROWDOWN: "ArrowDown",
};

export const FORECAST_WINDOW = {
  MIN: 1,
  MAX: 10,
};
export const MAX_TRAINS_FOR_BENCHMARK = 10;
export const PLOTLY_CLASS_NAME = {
  CLASS_NAME: ".js-plotly-plot",
};

export const ADVISOR_TYPES = {
  CA_ONLY: 1,
  RA_ONLY: 2,
  BOTH: 3,
};

export const STAGE_DEFAULTS = {
  NUM_PRESSURE_VESSELS: 3,
  NUM_ELEMENTS_PER_PV: 6,
};

export const DEFAULT_CIP_AMOUNT_PER_ELEMENT = {
  ACID: 0.028, // 0.5/18 ~ 0.028 per element
  ALKALI: 0.05, // 0.9/18 = 0.05 per element
};

export const DEFAULT_CIP_CHEMICALS = {
  ACID: {
    chem_id: 1,
    chemical_name: "HCl(32)",
  },
  ALKALI: {
    chem_id: 6,
    chemical_name: "NaOH(50)",
  },
  CIP_ADDITIVE: {
    chem_id: 10,
    chemical_name: "Na₂S₂O₄",
  },
};

export const CHINESE_CATEGORY_ALIASES = {
  酸: "acid",
  碱: "alkali",
  溶液: "cipadditive",
};

export const TECHNOLOGIES = {
  UF: "UF",
  IX: "IX",
  RO: "RO",
  IXD: "IXD",
  IXN: "IXN",
  IXB: "IXB",
  IXSD: "IXSD",
  IXMB: "IXMB",
  IXOS: "IXOS",
  CCRO: "CCRO",
  ROSC: "ROSC",
  IXCP: "IXCP",
  ISD: "ISD",
};

export const IX_TECHNOLOGIES = [
  TECHNOLOGIES.IX,
  TECHNOLOGIES.IXD,
  TECHNOLOGIES.IXMB,
];

export const PROJECT_VIEWS = {
  DESIGN: "System Design",
  FEED_SETUP: "Feed Setup",
  ...TECHNOLOGIES,
  REPORT: "Report",
};

export const CHEMICALS_SYMBOL_MAPPING = {
  "₀": "0",
  "₝": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
};

// As per bug 141619 hard limit is set for feed setup temperature as per the technology selected.
export const TEMPERARTURE_RANGES = {
  "°C": {
    soft: {
      min: 1,
      max: {
        UF: 40.0,
        IXD: 60.0,
        IXMB: 60.0,
      },
    },
    hard: {
      min: 0,
      max: {
        UF: 40.0,
        IXD: 60.0,
        IXMB: 60.0,
        IXOS: 60.0,
        IXN: 60.0,
        IXB: 60.0,
        IXCP: 60.0,
        RO: 80.0,
        IXSD: 100.0,
      },
    },
  },
  "°F": {
    soft: {
      min: 33.8,
      max: {
        UF: 104,
        IXD: 140,
        IXMB: 140,
      },
    },
    hard: {
      min: 32,
      max: {
        UF: 104,
        IXD: 140,
        IXMB: 140,
        IXOS: 140,
        IXN: 140,
        IXB: 140,
        IXCP: 140,
        RO: 176,
        IXSD: 212,
      },
    },
  },
};
export const FLOW_METRIC_UNIT = "m³/h";

export const DEFAULT_RECOVERY_VALUES = {
  UF: 99.12,
  IXD: 97,
  IXMB: 97,
  DEFAULT: 100,
};

export const STATUS_CODE = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  GATEWAY_TIMEOUT: 504,
};

export const PERCENTAGE_RANGE = {
  min: 0,
  max: 100,
};

export const CustomModalButtons = {
  CANCEL: "modal-cancel-btn",
  CONFIRM: "modal-confirm-btn",
  CLOSE: "modal-close-icon",
  DELETE: "modal-delete-btn",
  CLOSE_BTN: "modal-close-btn",
};

export const TRAIN_USAGE_MODAL_ACTIONS = Object.freeze({
  REPLACE: "replace",
  DELETE: "delete",
});

export const DEFAULT_STATE = (t) => ({
  stateName: t("openProjects.defaultState"),
});
export const DEFAULT_COUNTRY = (t) => ({
  countryName: t("openProjects.defaultCountry"),
});
export const DEFAULT_MARKET_SEGMENT = (t) => ({
  segmentName: t("openProjects.defaultMarketSegment"),
});
export const DEFAULT_MARKET_SEGMENT_FILTER = {
  segmentName: projectInfoModalStrings.defaultMarketSegmentFilter,
};

export const EXPORT_EXTENSION = ".dwpro";

export const FILTER_OPTIONS_OPEN_PROJECT = (t) => [
  {
    label: t("openProjects.equal"),
    value: "equal",
  },

  {
    label: t("openProjects.doesnotequal"),
    value: "doesnotequal",
  },
  {
    label: t("openProjects.beginswith"),
    value: "beginswith",
  },
  {
    label: t("openProjects.endswith"),
    value: "endswith",
  },
  {
    label: t("openProjects.contains"),
    value: "contains",
  },
  {
    label: t("openProjects.doesnotcontains"),
    value: "doesnotcontains",
  },
];

export const FILE_ACCESS_ACTIONS = {
  NEW_PROJECT: "openNewProject",
  OPEN_PROJECT: "showOpenProject",
  RECENT_PROJECT: "recentProjectClick",
  NAVIGATE_HOME: "navigateHome",
};

export const HTML_UNICODES = {
  DOWN_ARROW: "\u2193",
  UP_ARROW: "\u2191",
  SPACE: "\u00A0",
  CHECK_MARK: "\u2713",
};

export const LANGUAGE_CODES = {
  1: { code: "en", flag: usaFlag },
  8: { code: "zh", flag: chinaFlag },
};

export const FILE_UPLOAD = {
  MAX_FILE_SIZE: "10 MB", // 10 MB
  SUPPORTED_FILE_TYPES: ["XLS", "XLSX", "CSV"],
  CIP_BULK_UPLOAD_TEMPLATE: "CIP_bulk_upload_template.xlsx",
};

export const DEFAULT_PAGE_SIZE_OPTION = 50;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_CIP_KEYS = ["acid", "alkali", "cip_additive"];

const [ACID_KEY, ALKALI_KEY, CIP_ADDITIVE_KEY] = DEFAULT_CIP_KEYS;

export const CATEGORY_TO_CHEM_ID_KEY = {
  [ACID_KEY]: "acid_chem_id",
  [ALKALI_KEY]: "alkali_chem_id",
  [CIP_ADDITIVE_KEY]: "additional_chemical_chem_id",
};

export const CATEGORY_TO_ENABLED_KEY = {
  [ACID_KEY]: "acid_enabled",
  [ALKALI_KEY]: "alkali_enabled",
  [CIP_ADDITIVE_KEY]: "additional_chemical_enabled",
};

export const DEFAULT_CIP_API_KEY_MAP = {
  acidPrice: "acid_price",
  alkaliPrice: "alkali_price",
  acid_chemical: CATEGORY_TO_CHEM_ID_KEY[ACID_KEY],
  alkali_chemical: CATEGORY_TO_CHEM_ID_KEY[ALKALI_KEY],
  additional_chemical: CATEGORY_TO_CHEM_ID_KEY[CIP_ADDITIVE_KEY],
};

export const ViewTypeConstants = {
  VIEW_EDIT_PLANT: 1,
  VIEW_ANALYSE_DATA: 2,
  VIEW_HOME: 3,
};

export const CIP_SOURCE_OPTIONS = {
  BULK: "bulk",
  RECURRENT: "recurrent",
  USER: "user",
};

export const CIP_EVENT_TYPES = {
  C: "CIP",
  S: "shutdown",
};

export const CIP_TYPE_FORMATTER_STRINGS = {
  CIP: "cip",
  SHUTDOWN: "shutdown",
  C: "c",
  S: "s",
  SHUTDOWN_AS_PREDICTED: "shutdown (as predicted)",
  SHUTDOWN_WITH_CIP: "shutdown with cip",
};

export const DATA_APPEND_CONSTANTS = {
  UPLOAD: "upload",
  APPEND: "append",
  CHUNK_SIZE: 3 * 1024 * 1024,
};

export const DATA_APPEND_WARNING_SEVERITY_TYPES = {
  CRITICAL: "critical",
  WARNING: "warning",
  INFO: "info",
};

export const CIP_CARD_IDS = {
  BULK: "cip-bulk-card",
  RECURRENT: "cip-recurrent-card",
};

export const CIP_MISSING_VALIDATION = {
  ERROR_MESSAGE: "found missing events",
  ERROR_KEY: "missing_cip_event_prediction",
};

export const ALLOWED_MIN_CONVERSION_UNITS = ["temperature"];

export const UNIT_CONVERSION_CONFIG = {
  FLOW: {
    "m³/h": 1,
    "m³/d": 24,
    gpm: 1 / 0.227124,
  },
  PRESSURE: {
    bar: 1,
    psig: 1 / 0.0689476,
    psi: 1 / 0.0689476,
    kPa: 100,
  },
  TEMPERATURE: {
    C: { multiplier: 1, offset: 0 },
    "°C": { multiplier: 1, offset: 0 },
    F: { multiplier: 9 / 5, offset: 32 },
    "°F": { multiplier: 9 / 5, offset: 32 },
  },
  CONDUCTIVITY: {
    "uS/cm": 1,
    "µS/cm": 1,
    "mg/L": 0.64,
  },
};

export const MASS_KEYS = ["acidUsed", "alkaliUsed", "additiveUsed"];

export const PASS_STAGE_KEYS = ["sel_pass", "sel_stage"];

export const COLUMN_MAPPING_ERROR_KEYS = {
  NO_VALID_REF_CONDITION: "NO_VALID_REF_CONDITION",
};

export const NORMALIZATION_TYPES = {
  FT_NORM_PRO: "FT_NORM_PRO",
  CUSTOM: "CUSTOM",
  FT_NORM_FALLBACK: "FT_NORM_FALLBACK",
};

export const COLUMN_SELECTION_VALUES = {
  FT_NORM: "ftnorm",
  SELECT_COLUMNS: "selectColumns",
  MULTIPLE_ELEMENTS: "multiple-elements",
};

export const TOAST_DURATION_PER_WORD = 1000;

export const COMPARE_KEYS = {
  GREATER: "greater",
  LESS: "less",
};

export const CURRENCY_SYMBOLS = {
  Yuan: "¥/$",
  Euro: "€/$",
};

export const CURRENCIES = {
  USD: "USD",
  YUAN: "Yuan",
  EURO: "Euro",
};

export const CURRENCY_UNITS = {
  USD: "$",
  Yuan: "¥",
  Euro: "€",
};

// Element color palette using CSS variables
export const ELEMENT_COLOR_PALETTE = [
  "var(--dupont-element-color-blue)",
  "var(--dupont-element-color-green)",
  "var(--dupont-element-color-yellow)",
  "var(--dupont-element-color-pink)",
  "var(--dupont-element-color-purple)",
  "var(--dupont-element-color-red)",
];
export const ELEMENT_BG_PALETTE = [
  "var(--dupont-element-bg-blue)",
  "var(--dupont-element-bg-green)",
  "var(--dupont-element-bg-yellow)",
  "var(--dupont-element-bg-pink)",
  "var(--dupont-element-bg-purple)",
  "var(--dupont-element-bg-red)",
];
export const GREY_BG = "var(--dupont-element-bg-grey)";
export const GREY_BORDER = "var(--dupont-element-border-grey)";

export const FOULING_FAILURE_MODES = [
  "Integrity Failure",
  "Membrane Leak",
  "Oxidation",
  "Compaction",
];

export const STATUS_API_ERROR_KEYS = {
  NO_STABLE_POINTS: "NO_STABLE_POINTS",
  NO_PREDICTED_CIPS: "NO_PREDICTED_CIPS",
};

export const MODELING_UI_TEXT_KEYS = {
  PREDICTED_RECOMMENDED_CIPS_SAME: "PREDICTED_RECOMMENDED_CIPS_SAME",
};

export const DEFAULT_RADIO_COLUMNS = {
  column5: "feed_flowrate",
  column8: "concentrate_pressure",
};

export const DATA_APPEND_SECTION_ID = "data-append-section";

export const STATUS_KEYS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  FAILED: "failed",
};

export const CHART_EXPORT_CONFIG = {
  PLOT_AREA_HEIGHT: 140,
  MARGIN_TOP: 30,
  MARGIN_BOTTOM: 30,
};
